"use strict";

tinymce.baseURL = "Controls/Tinymce";
tinymce.suffix = ".min";

EWS.TinymceEdit = function (selector, language, callback, options) {
    const defaultOptions = {
        height: 300,
        elementpath: true,
        statusbar: true,
        toolbar: ["undo redo fontsizeselect bold italic hr alignleft aligncenter alignright alignjustify bullist numlist outdent indent link addreport table code language"],
        plugins: ["table link code hr addreport language"]
    };

    options = Object.assign({}, defaultOptions, options);

    return tinymce.init(Object.assign({
        selector,
        theme: "modern",
        theme_url: `${tinymce.baseURL}/themes/modern/theme.js`,
        // height: options.height,
        language,
        menubar: false,
        // plugins: options.plugins,
        // relative_urls: false,
        // elementpath: options.elementpath,
        // statusbar: options.statusbar,
        // remove_script_host: false,
        convert_urls: false,
        table_default_attributes: {
            height: "300px",
            width: "100%",
            border: "1px solid #eee",
            cellspacing: "0",
            cellpadding: "1",
            borderColor: "#eee"
        },
        table_default_styles: {
            "border-collapse": "collapse"
        },
        // toolbar: options.toolbar,
        init_instance_callback(editor) {
            // Task 1006408: Universal Search results do not hide after removing focus in Task Edit
            if (editor.contentDocument && editor.contentDocument.documentElement) {
                editor.contentDocument.documentElement.addEventListener("click", () => {
                    document.body.click();
                });
            }

            if (callback) {
                callback();
            }
        },
        valid_children: "+body[style]",
        extended_valid_elements: "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
            + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
            + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
            + "name|href|target|title|class|onfocus|onblur],strong/b,em/i,strike,u,"
            + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
            + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
            + "-blockquote,-table[border=0|cellspacing|cellpadding|width|frame|rules|"
            + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
            + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
            + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
            + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,-div,"
            + "-span,-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
            + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
            + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
            + "|height|src|*],script[src|type],map[name],area[shape|coords|href|alt|target],bdo,"
            + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
            + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
            + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
            + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
            + "q[cite],samp,select[disabled|multiple|name|size],small,"
            + "textarea[cols|rows|disabled|name|readonly],tt,var,big",
        setup: (editor) => {
            editor.on("change keyup redo undo", () => {
                editor.save();
            });
        }
    }, options));
};
